import { memo } from 'react';

import type { IconProps } from './types';
import BaseIcon from './BaseIcon';

export default memo((props: IconProps) => {
    return (
        <BaseIcon viewBox="0 0 18 18" fill="none" {...props}>
            <g clipPath="url(#clip0_6557_2961)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.01558 1.54286C2.62499 1.54286 2.2504 1.69802 1.97421 1.97421C1.69802 2.2504 1.54286 2.62499 1.54286 3.01558V5.25974C1.54286 5.65033 1.69802 6.02493 1.97421 6.30112C2.2504 6.57731 2.62499 6.73247 3.01558 6.73247H5.25974C5.65033 6.73247 6.02493 6.57731 6.30112 6.30112C6.57731 6.02493 6.73247 5.65033 6.73247 5.25974V3.01558C6.73247 2.62499 6.57731 2.2504 6.30112 1.97421C6.02493 1.69802 5.65033 1.54286 5.25974 1.54286H3.01558ZM0.883244 0.883244C1.44878 0.317713 2.2158 0 3.01558 0H5.25974C6.05952 0 6.82655 0.317713 7.39208 0.883244C7.95761 1.44878 8.27532 2.2158 8.27532 3.01558V5.25974C8.27532 6.05952 7.95761 6.82655 7.39208 7.39208C6.82655 7.95761 6.05952 8.27532 5.25974 8.27532H3.01558C2.2158 8.27532 1.44878 7.95761 0.883244 7.39208C0.317713 6.82655 0 6.05952 0 5.25974V3.01558C0 2.2158 0.317713 1.44878 0.883244 0.883244Z"
                    fill="currentColor"
                />
                <path
                    d="M10 4.13672C10 3.72251 10.1535 3.38672 10.3429 3.38672H17.6571C17.8465 3.38672 18 3.72251 18 4.13672C18 4.55093 17.8465 4.88672 17.6571 4.88672H10.3429C10.1535 4.88672 10 4.55093 10 4.13672Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.01558 11.2733C2.62499 11.2733 2.2504 11.4285 1.97421 11.7047C1.69802 11.9809 1.54286 12.3555 1.54286 12.7461V14.9902C1.54286 15.3808 1.69802 15.7554 1.97421 16.0316C2.2504 16.3078 2.62499 16.4629 3.01558 16.4629H5.25974C5.65033 16.4629 6.02493 16.3078 6.30112 16.0316C6.57731 15.7554 6.73247 15.3808 6.73247 14.9902V12.7461C6.73247 12.3555 6.57731 11.9809 6.30112 11.7047C6.02493 11.4285 5.65033 11.2733 5.25974 11.2733H3.01558ZM0.883244 10.6137C1.44878 10.0482 2.2158 9.73047 3.01558 9.73047H5.25974C6.05952 9.73047 6.82655 10.0482 7.39208 10.6137C7.95761 11.1792 8.27532 11.9463 8.27532 12.7461V14.9902C8.27532 15.79 7.95761 16.557 7.39208 17.1225C6.82655 17.6881 6.05952 18.0058 5.25974 18.0058H3.01558C2.2158 18.0058 1.44878 17.6881 0.883244 17.1225C0.317713 16.557 0 15.79 0 14.9902V12.7461C0 11.9463 0.317713 11.1792 0.883244 10.6137Z"
                    fill="currentColor"
                />
                <path
                    d="M10 13.8672C10 13.453 10.1535 13.1172 10.3429 13.1172H17.6571C17.8465 13.1172 18 13.453 18 13.8672C18 14.2814 17.8465 14.6172 17.6571 14.6172H10.3429C10.1535 14.6172 10 14.2814 10 13.8672Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_6557_2961">
                    <rect width="18" height="18" fill="currentColor" />
                </clipPath>
            </defs>
        </BaseIcon>
    );
});
